// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
//APIUrl: 'http://127.0.0.1:8000/api/',
APIUrl: 'https://api.shanbagscholarshipclass.in/api/',
firebaseConfig :{
  apiKey: "AIzaSyBkHZcdPNiPl3Up2aqq-ARy6EkRdUN78Ec",
  authDomain: "shanbag-class-b593d.firebaseapp.com",
  projectId: "shanbag-class-b593d",
  storageBucket: "shanbag-class-b593d.firebasestorage.app",
  messagingSenderId: "402218032808",
  appId: "1:402218032808:web:c0d52bb3cbc5574fb62c9d"
}
 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
